<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:24:52
 * @LastEditors: yd
 * @LastEditTime: 2020-12-08 15:53:47
--> 
<template>
  <div>
    <mrc_ess_iconGroup :is_disabled='readonly'
                       :showReturn='false'
                       :showEdit="hasBtn('edit-cost-center')"
                       :show_del="hasBtn('delete-cost-center')"
                       @handleEdit='handleEdit'
                       @handleDel='handleDel'></mrc_ess_iconGroup>
    <costCenter :disabled='readonly'
                @changereadonly='handleEdit'></costCenter>
  </div>
</template>

<script>
// import { deleteStaffLeave } from '@/service/api/staffmsg.js'
import {
  costCenterList,
  addCostCenter,
  delCostCenter,
  updateCostCenter,
  detailCostCenter,
} from '@/service/api/costCenter.js'
import costCenter from './costCenter'
export default {
  components: {
    costCenter
  },
  props: {},
  data () {
    return {
      readonly: false,
      list: {}
    };
  },
  computed: {},
  created () { },
  watch: {},
  mounted () {
    this.readonly = this.$store.state.iconstatus
  },
  beforeDestroy () {

  },
  methods: {
    handleEdit () {
      this.readonly = !this.readonly
      this.$store.commit('set_iconstatus', this.readonly)
    },
    handleDel () {
      this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') }).then(res => {
        delCostCenter({ uuid: this.$store.state.uuid }).then(res => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_The_deletion_was_successful') })
            this.$router.push({
              name: 'cost-center',
              params: {
                type: 'del'
              }
            })
          }
        })
      })
    },
  },
};
</script>

<style scoped>
</style>
